// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { bindActionCreatorsForm } from 'util/safeDispatch';
import { DIALOG_PANEL_SAVE_BUTTON_ID } from 'portfolio-shared/view/DialogPanel/DialogPanel';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import localizedStrings from 'util/localizedStrings';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import { getActivePanelId, getActivePanelData } from 'state/selectors';
import type { Dispatch, User } from 'state/types';
import { CONFIRM_USER_ROLE_CHANGE_PANEL_ID } from 'util/constants';

export type ConfirmRoleChangePanelData = {|
  affectedUsersCount: number,
  user: User,
  roleName: string,
|};

type Props = {
  activePanelId: ?string,
  activePanelData: ConfirmRoleChangePanelData,
  callback: ConfirmRoleChangePanelData => void,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
};

class ConfirmUserRoleChangeDialog extends Component<Props> {
  handleConfirm: Function;

  constructor() {
    super();
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleConfirm() {
    this.props.callback(this.props.activePanelData);
    this.props.hideDialogPanel();
  }

  render() {
    const {
      activePanelData,
      activePanelId,
      hideDialogPanel,
      intl: { formatMessage },
    } = this.props;

    const title =
      activePanelData && activePanelData.roleName === ''
        ? localizedStrings.REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE
        : localizedStrings.CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS;

    const message =
      activePanelData && activePanelData.roleName === ''
        ? localizedStrings.REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG
        : localizedStrings.CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG;

    const button =
      activePanelData && activePanelData.roleName === ''
        ? localizedStrings.REMOVE
        : localizedStrings.CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS;

    const args = (activePanelData && {
      affectedUsersCount: activePanelData.affectedUsersCount,
    }) || { affectedUsersCount: 1 };

    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '550px', height: null }}
        customButtonText={formatMessage(button, args)}
        dataTestName="confirm-user-role-change-dialog"
        dialogFocusId={DIALOG_PANEL_SAVE_BUTTON_ID}
        hideDialogPanel={hideDialogPanel}
        onSave={this.handleConfirm}
        panelId={CONFIRM_USER_ROLE_CHANGE_PANEL_ID}
        panelTitle={formatMessage(title, args)}
        showCancel
      >
        <div className="portfolio-form-container">
          {formatMessage(message, args)}
        </div>
      </DialogPanel>
    );
  }
}

export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
    activePanelData: getActivePanelData(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm({
      hideDialogPanel,
    })
)(injectIntl(ConfirmUserRoleChangeDialog));



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/ConfirmUserRoleChangeDialog.js